import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
import { PDF_MAPPINGS } from '../../../config/pdf-mapping';
import { RepAssessmentForm } from '../../interfaces/repassessmentform.interface';
@Injectable({
  providedIn: 'root'
})
export class PdfService {
  
 async generatePDF(templateName: string, formData: RepAssessmentForm) {

    const mapping = PDF_MAPPINGS[templateName];

    if (!mapping) {
      throw new Error(`Mapping not found: ${templateName}`);
    }

    const existingPdfBytes = await fetch(`assets/${mapping.file}`)
      .then(res => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();
  
    // const form = pdfDoc.getForm();

const fields = form.getFields();
//  console.log('PDF Fields:', form.getFields().map(f => f.getName()));
fields.forEach(field => {
  // console.log('FIELD:', field.getName());
  // console.log(field.getName(), field.constructor.name);
});

    // 🔹 Fill Fields (dynamic + typed)
    Object.entries(mapping.fields).forEach(([key, config]) => {

      const value = formData[key as keyof RepAssessmentForm];

      if (value === null || value === undefined) return;

      try {
        switch (config.type) {

          case 'text':
            form.getTextField(config.name).setText(String(value));
            break;

          case 'checkbox':
            value
              ? form.getCheckBox(config.name).check()
              : form.getCheckBox(config.name).uncheck();
            break;
        }

      } catch (e) {
        console.warn(`Field error: ${config.name}`);
      }

    });
    

    // 🔹 Signature (Robust)
   if (formData.signature && mapping.signature) {
  try {
    const pngImage = await pdfDoc.embedPng(formData.signature);

    try {
      const sigField = form.getButton(mapping.signature);
      sigField.setImage(pngImage);
    } catch {

      const field = form.getField(mapping.signature);
      const widget = field.acroField.getWidgets()[0];

      const rect = widget.getRectangle();
      const pageRef = widget.P();

      const pages = pdfDoc.getPages();
let page = pages.find(p => p.ref === pageRef);

//  fallback to first page (safety)
if (!page) {
  console.warn('Page not found, using first page');
  page = pages[0];
}

page.drawImage(pngImage, {
  x: rect.x,
  y: rect.y,
  width: rect.width,
  height: rect.height
});
    }

  } catch (e) {
    console.warn('Signature failed');
  }
}

    // 🔹 Flatten
    form.flatten();

    return await pdfDoc.save();
  }
}